import React from 'react'
import Filter from './Filter'
import useTranslation from "../../../../../i18n/useTranslation";

const StateFilter = (props) => {
    const { translate } = useTranslation()
    const {statusFilters, setStatusFilters, useInner=false} = props
    const pillColor = (item) => {
        switch (item) {
            case 'attended':
                return '#94E414'
            case 'missed':
                return '#FF3B24'
            case 'noshow':
                return '#FF3B24'
            case 'incomplete':
                return '#FFCA1A'
            case 'inprogress':
                return '#6666FF'
            case 'upcoming':
                return '#7182A4'
            case 'pending':
                return '#6666FF'
            default:
                return '#7182A4'
        }
    }
    const baseStatuses = [
        //missed,incomplete,noshow,finished,attended,upcoming,pending,inprogress
        {id: 'attended', label: 'Attended' || translate('calendar.sections.filters.inProgress'), statusColor: pillColor('attended')},
        {id: 'missed', label: translate('calendar.sections.filters.missed'), statusColor: pillColor('missed')},
        {id: 'noshow', label: translate('modal.infolesson.noshow'), statusColor: pillColor('noshow')},
        {id: 'incomplete', label: translate('calendar.sections.filters.incomplete'), statusColor: pillColor('incomplete')},
        // {id: 'finished', label: translate('calendar.sections.filters.completed')},
        {id: 'inprogress', label: 'In progress', statusColor: pillColor('inprogress')},
        {id: 'upcoming', label: translate('calendar.sections.filters.upcoming'), statusColor: pillColor('upcoming')},
        {id: 'pending', label: 'Pending', statusColor: pillColor('pending')}
    ]
    return (
        <Filter showOptionComponents {...{statuses: baseStatuses, statusFilters, setStatusFilters, useInner}} />
    )
}

export default StateFilter
